import { IEnvironnements } from "./environnements";

export const calculQueryEnv = (envsSelected:{
    name: string;
    code: string;
  }[]) => {
    let queryParams = "";
    for (let i = 0; i < envsSelected.length; i++) {
      if (i === envsSelected.length - 1) {
        queryParams = queryParams + envsSelected[i].code;
      } else {
        queryParams = queryParams + envsSelected[i].code + ",";
      }
    }
    if (queryParams === "")return "BAS,EID,PROD"
    return queryParams.toUpperCase();
}

export const convertQueryEnvToDropDownEnvValue = (envs:string | null, environnements: IEnvironnements[]) => {
  if(!envs)return []
  const queryEnvArray = envs.split(",");
  const envArray:IEnvironnements[] = []
  for(let env of queryEnvArray) {
    let envValue = environnements?.find((value) => value.code === env)
    if(envValue)envArray.push(envValue)
  }
  return envArray
}